module.exports = __webpack_public_path__ + "static/assets/3115093c9dad31d285a8a694a06cced0.png";